const roles = ["user", "user_special", "colab", "editor", "admin"];

const hasPermission = (userRole, requiredRole) => {
    const userLevel = roles.indexOf(userRole);
    const requiredLevel = roles.indexOf(requiredRole);
    return userLevel !== -1 && requiredLevel !== -1 && userLevel >= requiredLevel;
};

export default hasPermission;
